import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[smTabContent]',
    standalone: false
})
export class SmTabContentDirective {
    constructor(public templateRef: TemplateRef<unknown>) {}
}
